module.exports = __webpack_public_path__ + "img/platform_ser_qkl_01@2x.117bc471.png";